import { Component, OnInit, NgZone, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { CreateAccountService } from './create-account.service';
import { IAccount } from './account';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import {
  FormBuilder,
  Validators,
  FormControl,
  FormGroup,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ICustomer } from '../home/customer';
import { Subscription } from 'rxjs';
import { IZip } from './zipinfo';
import { LoginService } from '../home/login.service';
import { IRep } from '../home/rep';
import { ProductService } from '../products/products.service';
import { AppComponent } from '../app.component';
import { PasswordValidation } from './password-validation';
import { IAddress } from './address';
import { ValidateAddressComponent } from './validate-address.component';
import { ViewChild, ElementRef } from '@angular/core';
import { OnlineOrderService } from '../onlineorder/onlineorder.service';
import { ICartItems } from '../onlineorder/cartitems';
import { OrderService } from '../onlineorder/order.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { IRepPublicData } from '../home/repPublicData';
import { IReferralMarketTypes } from './referralMarketTypes';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from '../admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ICustomerInfoResponse } from './customerinforesponse';
import { IAuthData } from '../seamlessauth/authData';
import { SUPPORTED_LANGUAGES } from '../generic/supported-languages';
import { environment } from 'environments/environment';
import { AppConfigService } from '../admin/app-config.service';
@Component({
  standalone: false,
  templateUrl: './create-account.component.html',
})
export class CreateAccountComponent implements OnInit {
  @ViewChild('contentStuff') content: TemplateRef<any>;
  @ViewChild('submitButton') submitButton!: ElementRef;
  pageTitle: string = 'Create your account';
  @ViewChild('selectDropDown') langSelect: ElementRef;
  myCustId!: string;
  custPlaceHolder!: string;
  customer!: ICustomer;
  accounts!: IAccount[];
  languages = SUPPORTED_LANGUAGES;
  refMarketTypes!: IReferralMarketTypes[];
  displayRefMarketTypes: IReferralMarketTypes[] = [];
  addresses!: IAddress;
  rep!: IRepPublicData;
  counties!: string[];
  states!: string[];
  cities!: string[];
  closeResult: string;
  zipGood: boolean = false;
  marketTypes = Array<marketType>();
  zipResults!: IZip[];
  public token: any;
  private sub!: Subscription;
  errorMessage!: string;
  zipErrorMessage!: string;
  public emailGood: boolean = false;
  public dupEmail: boolean = false;
  public options = {
    position: ['bottom', 'right'],
    timeOut: 6000,
    lastOnBottom: true,
    preventDuplicates: true,
    preventLastDuplicates: false,
  };
  public caption: string;
  public transErrMsg: string;
  translatedText = '';

  public loginInfo: any;
  public checkResult: boolean = false;
  public cartItems!: ICartItems[];
  public allCustInfo: ICustomerInfoResponse;
  public authData: IAuthData;
  // openLoginDialog() {
  //     return this.modal.open(ValidateAddressComponent, overlayConfigFactory({}, BSModalContext));
  // }
  getLocale(): any {
    var currentLocale = localStorage.getItem('locale');
    return currentLocale;
  }
  googleTranslateCall(textToTrans: string, targetLang: string): string {
    let model = {
      q: [textToTrans],
      target: targetLang,
    };
    this.admin.googleTranslate(model).subscribe((response: any) => {
      //console.log('Translate Call: ' + response.data.translations[0].translatedText);
      this.translatedText = response.data.translations[0].translatedText;
      return this.translatedText;
    });
    return '';
  }
  showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
    //use this for dynamic error messages
    if (staticErrorMsg === false) {
      let locale = this.getLocale();
      if (locale !== 'en') {
        //were gonna do it nested, couldn't do it as a standalone method.
        let model = {
          q: [errorMessage],
          target: locale,
        };

        this.admin.googleTranslate(model).subscribe(
          (response: any) => {
            let res = response.data.translations[0].translatedText as string;
            this.translatedText = response.data.translations[0]
              .translatedText as string;
            this.transErrMsg = this.translatedText;
            localStorage.setItem('translatedText', res);
          },
          (error) => console.log(error),
          () => {
            this.translate.get(subject).subscribe(
              (res: string) => {
                this.caption = res;
                console.log(res);
              },
              (error) => console.log(error),
              () => {
                this.spinner.hide();
                //once the caption is translated, fire off the toaster popup
                this.toaster.error(this.transErrMsg, this.caption, {
                  timeOut: 5000,
                });
                localStorage.removeItem('translatedText');
              }
            );
          }
        );

        //this.transErrMsg =  this.translatedText;
      } else {
        this.translate.get(subject).subscribe(
          (res: string) => {
            this.caption = res;
            console.log(res);
          },
          (error) => console.log(error),
          () => {
            this.transErrMsg = errorMessage;
            this.spinner.hide();
            //once the caption is translated, fire off the toaster popup
            this.toaster.error(this.transErrMsg, this.caption, {
              timeOut: 5000,
            });
            localStorage.removeItem('translatedText');
          }
        );
      }
    } else {
      // translate the error message - not dynamic
      this.translate.get(errorMessage).subscribe((res: string) => {
        this.transErrMsg = res;
        console.log(res);
      });

      // translate the caption
      this.translate.get(subject).subscribe((res: string) => {
        this.caption = res;
        console.log(res);
      });
      this.spinner.hide();
      //show the toaster popup
      this.toaster.error(this.transErrMsg, this.caption, {
        timeOut: 5000,
      });
    }
  }
  repId(): any {
    var currentId = localStorage.getItem('repId');
    return currentId;
  }
  forceNavigate(name: string) {
    this.router.navigate(
      ['/createAccount/from/' + localStorage.getItem('repId')],
      { fragment: name }
    );
  }
  editAddress() {
    this.modal.dismissAll();
    this.submitButton.nativeElement.disabled = false;
    this.forceNavigate('address');
  }
  public createAccountForm = this.fb.group(
    {
      custFirst: ['', Validators.required],
      custLast: ['', Validators.required],
      custEmail: [
        '',
        Validators.compose([Validators.required, Validators.email]),
      ],
      custPass: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(40),
        ]),
      ],
      custPass2: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(40),
        ]),
      ],
      custStreet: ['', Validators.required],
      custCity: ['', Validators.required],
      custCounty: ['', Validators.required],
      custState: ['', Validators.required],
      custZip: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(10),
        ]),
      ],
      custPhone: ['', Validators.required],
      custHow: ['', Validators.required],
      custMessage: ['', Validators.required],
      custLocale: ['en', Validators.required],
      // btnCreate: []
    },
    {
      validator: PasswordValidation.MatchPassword,
    }
  );

  constructor(
    public fb: FormBuilder,
    private _createAccountService: CreateAccountService,
    private toaster: ToastrService,
    private router: Router,
    public login: LoginService,
    private _productService: ProductService,
    private _route: ActivatedRoute,
    private _router: Router,
    public app: AppComponent,
    public onlineorder: OnlineOrderService,
    private zone: NgZone,
    private modal: NgbModal,
    private orderService: OrderService,
    public translate: TranslateService,
    public admin: AdminService,
    public spinner: NgxSpinnerService,
  private cdRef: ChangeDetectorRef,
  private appConfig: AppConfigService
  ) {
    const control = this.createAccountForm.get('custLocale');

    if (control && !control.touched) {
      control.markAsTouched();
    }
  }
  open(content) {
    this.modal
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  // mergeItemsError(): void {

  //     this.toaster.error("Could only add some items to your order, some items have been previously ordered.", "Error", {
  //         timeOut: 3000
  //     });
  // }

  //   isNotDuplicate(input: FormControl)
  //     {
  //         return this._createAccountService.checkDuplicateEmail(input.value).subscribe();
  //     }

  showSuccess(message: string, subject: string, staticMsg: boolean): void {
    // translate the error message - not dynamic
    this.translate.get(message).subscribe((res: string) => {
      this.transErrMsg = res;
      console.log(res);
    });

    // translate the caption
    this.translate.get(subject).subscribe((res: string) => {
      this.caption = res;
      console.log(res);
    });
    //show the toaster popup
    this.toaster.success(this.transErrMsg, this.caption, {
      timeOut: 3000,
    });
  }

  createSuccess(message: string, caption: string): void {
    // translate the error message - not dynamic
    this.translate.get(message).subscribe((res: string) => {
      this.transErrMsg = res;
      console.log(res);
    });

    // translate the caption
    this.translate.get(caption).subscribe((res: string) => {
      this.caption = res;
      console.log(res);
    });
    this.toaster.success(this.transErrMsg, this.caption, {
      timeOut: 3000,
    });

    setTimeout((router: Router) => {
      this.router.navigate(['/shop/from/' + this.repId()]);
    }, 2000);
  }

  // createError(): void {

  //     this.toaster.error("Failed to create account", "Error", {
  //         timeOut: 3000
  //     });
  // }
  checkEmailAdd() {
    this._createAccountService
      .checkEmail(this.createAccountForm.controls['custEmail'].value)
      .subscribe(
        (thing) => {
          this.emailGood = thing;
          if (thing == false) {
            //this.createAccountForm.
            this.errorMessage =
              'createAccount.fields.validation.errors.emails.notValidFormat';
            this.translate.get(this.errorMessage).subscribe((res: string) => {
              this.transErrMsg = res;
              this.errorMessage = res;
              console.log(res);
            });
          }
        },
        (error) => {
          this.errorMessage =
            'createAccount.fields.validation.errors.emails.incorrect';
          this.translate.get(this.errorMessage).subscribe((res: string) => {
            this.transErrMsg = res;
            this.errorMessage = res;
            console.log(res);
          });
        },
        () => {
          if (this.emailGood == true) {
            this._createAccountService
              .checkDuplicateEmail(
                this.createAccountForm.controls['custEmail'].value
              )
              .subscribe((thing) => {
                this.dupEmail = thing;
                if (thing == false) {
                  this.errorMessage =
                    'createAccount.fields.validation.errors.emails.duplicate';
                  this.translate
                    .get(this.errorMessage)
                    .subscribe((res: string) => {
                      this.transErrMsg = res;
                      this.errorMessage = res;
                      console.log(res);
                    });
                  this.createAccountForm.controls['custEmail'].setErrors(
                    (error: string) => (error = this.transErrMsg)
                  );
                  // this.submitButton.nativeElement.disabled = true;
                }
                // else{
                //     if(this.createAccountForm.status === "VALID")
                //     {
                //         this.submitButton.nativeElement.disabled = false;
                //     }

                // }
              });
          }
        }
      );

    //console.log("Email Good " + this.emailGood);
    return this.emailGood;
    //console.log(this.createAccountForm.controls.custEmail.value);
  }
  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (
        matchingControl.errors &&
        !matchingControl.errors['confirmedValidator']
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  onButtonClick() {
    this.submitButton.nativeElement.disabled = true;
    //Do some other stuff, maybe call a service etc...
    //this.submitButton.nativeElement.disabled = false;
  }
  getZipInfo() {
    this.counties = [];
    this.cities = [];
    this.states = [];
    if (this.createAccountForm.controls['custZip'].value.length >= 5) {
      this._createAccountService
        .zipLookup(this.createAccountForm.controls['custZip'].value)
        .subscribe((info) => {
          this.zipResults = info;
          //console.log(this.zipResults.length);

          if (info.length !== 0) {
            this.zipGood = true;
          } else {
            this.zipGood = false;
            this.zipErrorMessage = 'createAccount.fields.validation.errors.zip';
            this.translate
              .get(this.zipErrorMessage)
              .subscribe((res: string) => {
                this.transErrMsg = res;
                this.zipErrorMessage = res;
                console.log(res);
              });
          }

          this.zipResults.forEach(
            (item) => {
              //console.log(item.City);
              //console.log(item.City);
              this.createAccountForm.controls['custCity'].setValue(item.City);
              this.createAccountForm.controls['custState'].setValue(item.State);
              this.createAccountForm.controls['custCounty'].setValue(
                item.County
              );
              if (!this.states.some((x) => x === item.State)) {
                this.states.push(item.State);
              }

              if (!this.counties.some((x) => x === item.County)) {
                this.counties.push(item.County);
              }
              if (!this.cities.some((x) => x === item.City)) {
                this.cities.push(item.City);
              }
            },
            (error: any) => {
              this.zipGood = false;
              this.zipErrorMessage =
                'createAccount.fields.validation.errors.zip';
              this.translate
                .get(this.zipErrorMessage)
                .subscribe((res: string) => {
                  this.transErrMsg = res;
                  this.zipErrorMessage = res;
                  console.log(res);
                });
            }
          );
        });
    } else {
      this.zipGood = false;
      this.zipErrorMessage = 'createAccount.fields.validation.errors.zip';
    }
    return this.zipGood;
  }
  onSubmit(): void {
    this.submitButton.nativeElement.disabled = true;
    this._createAccountService
      .validateAddress(
        this.createAccountForm.controls['custFirst'].value,
        this.createAccountForm.controls['custLast'].value,
        this.createAccountForm.controls['custStreet'].value,
        this.createAccountForm.controls['custCity'].value,
        this.createAccountForm.controls['custState'].value,
        this.createAccountForm.controls['custZip'].value,
        this.createAccountForm.controls['custCounty'].value
      )
      .subscribe(
        (data) => {
          this.addresses = data;
          this._createAccountService.addresses = data;
          localStorage.setItem(
            'accountCreateFields',
            JSON.stringify({
              RepDID: this.repId(),
              FirstName: this.createAccountForm.controls['custFirst'].value,
              LastName: this.createAccountForm.controls['custLast'].value,
              Email: this.createAccountForm.controls['custEmail'].value,
              Phone: this.createAccountForm.controls['custPhone'].value,
              Password: this.createAccountForm.controls['custPass'].value,
              How: this.createAccountForm.controls['custHow'].value,
              Message: this.createAccountForm.controls['custMessage'].value,
              Street: this.createAccountForm.controls['custStreet'].value,
              City: this.createAccountForm.controls['custCity'].value,
              State: this.createAccountForm.controls['custState'].value,
              PostalCode: this.createAccountForm.controls['custZip'].value,
              County: this.createAccountForm.controls['custCounty'].value,
            })
          );
          //console.log("create acct comp: " + this.addresses);
          //localStorage.setItem('validAddress', JSON.stringify(data));
        },
        (error) => {
          console.log(error);
          this.submitButton.nativeElement.disabled = false;
        },
        () => {
          //console.log(this.addresses);
          if (this.addresses.Street1 == null) {
            this._createAccountService
              .createAccount2(
                this.repId(),
                this.createAccountForm.controls['custFirst'].value,
                this.createAccountForm.controls['custLast'].value,
                this.createAccountForm.controls['custStreet'].value,
                this.createAccountForm.controls['custCity'].value,
                this.createAccountForm.controls['custState'].value,
                this.createAccountForm.controls['custZip'].value,
                this.createAccountForm.controls['custPhone'].value,
                this.createAccountForm.controls['custPass'].value,
                this.createAccountForm.controls['custEmail'].value,
                this.createAccountForm.controls['custCounty'].value,
                this.createAccountForm.controls['custHow'].value,
                this.createAccountForm.controls['custMessage'].value
              )
              .subscribe(
                (data) => (this.myCustId = data),
                (error) => {
                  this.showError(
                    'createAccount.toastPopup.errors.createAccountError',
                    'Error',
                    true
                  );
                  this.submitButton.nativeElement.disabled = false;
                },
                () =>
                  this.login
                    .someLogin(
                      this.createAccountForm.controls['custEmail'].value,
                      this.createAccountForm.controls['custPass'].value
                    )
                    .subscribe(
                      (data: any) => (this.token = data),
                      (error: any) =>
                        this.showError(
                          'createAccount.toastPopup.errors.createAccountError',
                          'Error',
                          true
                        ),
                      () =>
                        // {
                        //     this.login.isAuthenticated = true;
                        //     this.app.loggedIn = true;
                        //     this.createSuccess()

                        // }
                        {
                          this.login.isAuthenticated = true;
                          this.app.loggedIn = true;
                          // this._createAccountService.createNote(this.myCustId,
                          //     cust.How + " - " +
                          //     cust.Message).subscribe(data => console.log(data),
                          //     error => this.createError(), () => {
                          //this.dialog.close();
                          this.createSuccess(
                            'createAccount.toastPopup.success.createAccount',
                            'createAccount.toastPopup.titles.generic.success'
                          );
                          if (this.login.loggedIn()) {
                            this._createAccountService
                              .getCustomerInfo(this.authData.userName)
                              .subscribe({
                                next: (custRes) => {
                                  this.allCustInfo = custRes;
                                  // set this to be used later.
                                  localStorage.setItem(
                                    'allCustInfo',
                                    JSON.stringify(this.allCustInfo)
                                  );
                                  let custName = (
                                    custRes.FirstName +
                                    ' ' +
                                    custRes.LastName
                                  )
                                    .toString()
                                    .replace('"', '');
                                  localStorage.setItem('custName', custName);
                                },
                                complete: () => {
                                  this.onlineorder
                                    .latestOnlineOrder()
                                    .subscribe(
                                      null,
                                      (error: string) =>
                                        (this.errorMessage = error),
                                      () => {
                                        this.onlineorder.clearOrder().subscribe(
                                          null,
                                          (error: string) =>
                                            (this.errorMessage = error),
                                          () => {
                                            if (
                                              this.onlineorder.getCart()
                                                .length > 0
                                            ) {
                                              this.cartItems =
                                                this.onlineorder.getCart();
                                              var prodC = 0;
                                              for (
                                                var i = 0;
                                                i <
                                                this.onlineorder.getCart()
                                                  .length;
                                                i++
                                              ) {
                                                // see if any of the items have been ordered, if not add them to online order.
                                                this.onlineorder
                                                  .checkIfOrdered2(
                                                    this.cartItems[i].ProductId
                                                  )
                                                  .subscribe(
                                                    null,
                                                    () => {
                                                      //for (var t = 0; t < this.cartItems.length; t++) {

                                                      // this.checkResult = thing;
                                                      //console.log(prodC);
                                                      // if (this.checkResult === false && prodC <= i) {
                                                      if (prodC <= i) {
                                                        //console.log("good");
                                                        this.onlineorder
                                                          .mergeToOrder(prodC)
                                                          .subscribe(
                                                            null,
                                                            (error: string) =>
                                                              (this.errorMessage =
                                                                error),
                                                            () =>
                                                              this.onlineorder
                                                                .updateShipMethodPlusTotals2()
                                                                .subscribe()
                                                          );
                                                        prodC++;
                                                      } else if (
                                                        prodC <=
                                                        this.onlineorder.cart
                                                          .length
                                                      ) {
                                                        // need to kick out the bad item
                                                        console.log(prodC);
                                                        var badItem: ICartItems =
                                                          {
                                                            ProductId:
                                                              this.cartItems[
                                                                prodC
                                                              ].ProductId,
                                                            DisplayName:
                                                              this.cartItems[
                                                                prodC
                                                              ].DisplayName,
                                                            ImageUrl:
                                                              this.cartItems[
                                                                prodC
                                                              ].ImageUrl,
                                                            Price:
                                                              this.cartItems[
                                                                prodC
                                                              ].Price,
                                                            Quantity:
                                                              this.cartItems[
                                                                prodC
                                                              ].Quantity,
                                                          };
                                                        //this.cartItems = this.onlineorder.deleteItem(badItem);
                                                        this.onlineorder.cart =
                                                          this.onlineorder.deleteItem(
                                                            badItem
                                                          );
                                                        //console.log(JSON.stringify(this.onlineorder.cart));
                                                        localStorage.removeItem(
                                                          'cartItems'
                                                        );
                                                        localStorage.setItem(
                                                          'cartItems',
                                                          JSON.stringify(
                                                            this.onlineorder.getCart()
                                                          )
                                                        );
                                                        var newCount =
                                                          localStorage.getItem(
                                                            'prodCount'
                                                          );

                                                        var count =
                                                          Number(newCount) - 1;
                                                        localStorage.removeItem(
                                                          'prodCount'
                                                        );
                                                        localStorage.setItem(
                                                          'prodCount',
                                                          count.toString()
                                                        );

                                                        this.cartItems =
                                                          this.onlineorder.getCart();
                                                        //this.cartItems = this.onlineorder.getCart();
                                                        this.onlineorder
                                                          .updateShipMethodPlusTotals2()
                                                          .subscribe();
                                                        this.showError(
                                                          'login.toastPopup.errors.mergeError',
                                                          'login.toastPopup.errors.titles.mergeErrorTitle',
                                                          true
                                                        );
                                                        //prodC++;
                                                        //i--;
                                                      }

                                                      //console.log(JSON.stringify(this.cartItems) + " Product Count Index: " + prodC);
                                                      //}
                                                    },
                                                    () => {
                                                      console.log(prodC);
                                                      var badItem: ICartItems =
                                                        {
                                                          ProductId:
                                                            this.cartItems[
                                                              prodC
                                                            ].ProductId,
                                                          DisplayName:
                                                            this.cartItems[
                                                              prodC
                                                            ].DisplayName,
                                                          ImageUrl:
                                                            this.cartItems[
                                                              prodC
                                                            ].ImageUrl,
                                                          Price:
                                                            this.cartItems[
                                                              prodC
                                                            ].Price,
                                                          Quantity:
                                                            this.cartItems[
                                                              prodC
                                                            ].Quantity,
                                                        };
                                                      //this.cartItems = this.onlineorder.deleteItem(badItem);
                                                      this.onlineorder.cart =
                                                        this.onlineorder.deleteItem(
                                                          badItem
                                                        );
                                                      //console.log(JSON.stringify(this.onlineorder.cart));
                                                      localStorage.removeItem(
                                                        'cartItems'
                                                      );
                                                      localStorage.setItem(
                                                        'cartItems',
                                                        JSON.stringify(
                                                          this.onlineorder.getCart()
                                                        )
                                                      );
                                                      var newCount =
                                                        localStorage.getItem(
                                                          'prodCount'
                                                        );

                                                      var count =
                                                        Number(newCount) - 1;
                                                      localStorage.removeItem(
                                                        'prodCount'
                                                      );
                                                      localStorage.setItem(
                                                        'prodCount',
                                                        count.toString()
                                                      );

                                                      this.cartItems =
                                                        this.onlineorder.getCart();
                                                      //this.cartItems = this.onlineorder.getCart();
                                                      this.onlineorder
                                                        .updateShipMethodPlusTotals2()
                                                        .subscribe();
                                                      this.showError(
                                                        'login.toastPopup.errors.mergeError',
                                                        'login.toastPopup.errors.titles.mergeErrorTitle',
                                                        true
                                                      );
                                                    }
                                                    // this.checkResult = thing, error => console.log(error), () => {

                                                    // }
                                                  );
                                              }
                                            }
                                            this.zone.run(() => {
                                              setTimeout((router: Router) => {
                                                this.app.myRepID = this.repId();
                                                this.router.navigateByUrl(
                                                  'shop/from/' + this.repId()
                                                );
                                              }, 1000);
                                            });
                                          }
                                        );
                                      }
                                    );
                                },
                              });
                          }
                        }
                    )
              );
          } else {
            // open the modal if a good match is found.
            this.open(this.content);
            //this.openLoginDialog();
          }
        }
      );
  }

  onSubmit2(): void {
    this.submitButton.nativeElement.disabled = true;
    //this.spinner.show();
    this._createAccountService
      .validateAddress(
        this.createAccountForm.controls['custFirst'].value,
        this.createAccountForm.controls['custLast'].value,
        this.createAccountForm.controls['custStreet'].value,
        this.createAccountForm.controls['custCity'].value,
        this.createAccountForm.controls['custState'].value,
        this.createAccountForm.controls['custZip'].value,
        this.createAccountForm.controls['custCounty'].value
      )
      .subscribe(
        (data) => {
          this.addresses = data;
          if (data.Street1 === null) this.addresses = null;
          localStorage.setItem('validatedAddress', JSON.stringify(data));
          this._createAccountService.addresses = data;
          localStorage.setItem(
            'accountCreateFields',
            JSON.stringify({
              RepDID: this.repId(),
              FirstName: this.createAccountForm.controls['custFirst'].value,
              LastName: this.createAccountForm.controls['custLast'].value,
              Email: this.createAccountForm.controls['custEmail'].value,
              Phone: this.createAccountForm.controls['custPhone'].value,
              Password: this.createAccountForm.controls['custPass'].value,
              How: this.createAccountForm.controls['custHow'].value,
              Message: this.createAccountForm.controls['custMessage'].value,
              Street: this.createAccountForm.controls['custStreet'].value,
              City: this.createAccountForm.controls['custCity'].value,
              State: this.createAccountForm.controls['custState'].value,
              PostalCode: this.createAccountForm.controls['custZip'].value,
              County: this.createAccountForm.controls['custCounty'].value,
            })
          );
          //console.log("create acct comp: " + this.addresses);
          //localStorage.setItem('validAddress', JSON.stringify(data));
        },
        (error) => {
          console.log(error);
          this.submitButton.nativeElement.disabled = false;
        },
        () => {
         // this.open(this.content);
          if (this.appConfig.bypassAddressValidation) {
            this.createAccountBypassValidation();
          } else {
            this.open(this.content);
          }
        }
      );
  }
private createAccountBypassValidation(): void {
    this.spinner.show();
    var cust = JSON.parse(localStorage.getItem('accountCreateFields') || '{}');
    this._createAccountService
      .createAccount2(
        cust.RepDID,
        cust.FirstName,
        cust.LastName,
        cust.Street,
        cust.City,
        cust.State,
        cust.PostalCode,
        cust.Phone,
        cust.Password,
        cust.Email,
        cust.County,
        cust.How,
        cust.Message
      )
      .subscribe(
        (data) => (this.myCustId = data),
        (error) => {
          this.showError(
            'createAccount.toastPopup.errors.createAccountError',
            'Error',
            true
          );
          this.submitButton.nativeElement.disabled = false;
        },
        () =>
          this.login.someLogin(cust.Email, cust.Password).subscribe(
            (data: any) => (this.token = data),
            (error: any) =>
              this.showError(
                'createAccount.toastPopup.errors.createAccountError',
                'Error',
                true
              ),
            () => {
              this.login.getLbriWebApiToken().subscribe(
                (thing) => (this.loginInfo = thing),
                (error) => console.log(error),
                () => {
                  this.login.isAuthenticated = true;
                  this.app.loggedIn = true;
                  localStorage.setItem('cameFromCreateAccount', 'True');
                  this.createSuccess(
                    'createAccount.toastPopup.success.createAccount',
                    'createAccount.toastPopup.titles.generic.success'
                  );
                  if (this.login.loggedIn()) {
                    var myAuth = JSON.parse(
                      localStorage.getItem('authorizationData')
                    );
                    this._createAccountService
                      .getCustomerInfo(myAuth.userName)
                      .subscribe({
                        next: (custRes) => {
                          this.allCustInfo = custRes;
                          localStorage.setItem(
                            'allCustInfo',
                            JSON.stringify(this.allCustInfo)
                          );
                          localStorage.setItem(
                            'shippingData',
                            JSON.stringify({
                              first: this.allCustInfo.FirstName,
                              last: this.allCustInfo.LastName,
                              street1: this.allCustInfo.ShipStreet1,
                              street2: this.allCustInfo.ShipStreet2,
                              city: this.allCustInfo.ShipCity,
                              state: this.allCustInfo.ShipState,
                              zip: this.allCustInfo.ShipPostalCode,
                              county: this.allCustInfo.ShipCounty,
                              country: 'USA',
                              email: this.allCustInfo.Email,
                              phone: this.allCustInfo.Phone1,
                            })
                          );
                          let custName = (
                            custRes.FirstName +
                            ' ' +
                            custRes.LastName
                          )
                            .toString()
                            .replace('"', '');
                          localStorage.setItem('custName', custName);
                          if (this.allCustInfo.PreferredCulture === 1)
                            this.app.useLanguage('en');
                          else this.app.useLanguage('es');
                        },
                        complete: () => {
                          this.onlineorder.latestOnlineOrder().subscribe(
                            (thing2) => (this.loginInfo = thing2),
                            (error) => (this.errorMessage = error),
                            () => {
                              if (environment.logrocketEnabled) {
                                let orderInfo = JSON.parse(
                                  localStorage.getItem('orderId')
                                );
                                this.login.setCurrentUser(
                                  this.allCustInfo,
                                  orderInfo.ID
                                );
                              }
                              this.onlineorder.changeMarketType().subscribe({
                                next: (v) => '',
                                error: (e) => console.error(e),
                                complete: () => {
                                  if (this.orderService.getCart().length > 0) {
                                    this.cartItems =
                                      this.orderService.getCart();
                                    var prodC = 0;
                                    for (
                                      var i = 0;
                                      i < this.orderService.getCart().length;
                                      i++
                                    ) {
                                      this.orderService
                                        .checkIfOrdered2(
                                          this.cartItems[i].ProductId
                                        )
                                        .subscribe(
                                          null,
                                          () => {
                                            if (prodC <= i) {
                                              this.orderService
                                                .mergeToOrder(prodC)
                                                .subscribe(
                                                  null,
                                                  (error) =>
                                                    (this.errorMessage = error),
                                                  () => {
                                                    this.onlineorder
                                                      .calculateTax()
                                                      .subscribe(
                                                        (thing2) => thing2,
                                                        (error) =>
                                                          console.log(error),
                                                        () => {
                                                          this.orderService
                                                            .updateShipMethodPlusTotals2()
                                                            .subscribe();
                                                        }
                                                      );
                                                  }
                                                );
                                              prodC++;
                                            } else if (
                                              prodC <=
                                              this.orderService.cart.length
                                            ) {
                                              var badItem: ICartItems = {
                                                ProductId:
                                                  this.cartItems[prodC]
                                                    .ProductId,
                                                DisplayName:
                                                  this.cartItems[prodC]
                                                    .DisplayName,
                                                ImageUrl:
                                                  this.cartItems[prodC]
                                                    .ImageUrl,
                                                Price:
                                                  this.cartItems[prodC].Price,
                                                Quantity:
                                                  this.cartItems[prodC]
                                                    .Quantity,
                                              };
                                              this.orderService.cart =
                                                this.orderService.deleteItem(
                                                  badItem
                                                );
                                              localStorage.removeItem(
                                                'cartItems'
                                              );
                                              localStorage.setItem(
                                                'cartItems',
                                                JSON.stringify(
                                                  this.orderService.getCart()
                                                )
                                              );
                                              var newCount =
                                                localStorage.getItem(
                                                  'prodCount'
                                                );
                                              var count = Number(newCount) - 1;
                                              localStorage.removeItem(
                                                'prodCount'
                                              );
                                              localStorage.setItem(
                                                'prodCount',
                                                count.toString()
                                              );
                                              this.cartItems =
                                                this.orderService.getCart();
                                              this.onlineorder
                                                .calculateTax()
                                                .subscribe(
                                                  (thing2) => thing2,
                                                  (error) => console.log(error),
                                                  () => {
                                                    this.orderService
                                                      .updateShipMethodPlusTotals2()
                                                      .subscribe();
                                                  }
                                                );
                                              this.showError(
                                                'createAccount.toastPopup.errors.createAccountError',
                                                'Error',
                                                true
                                              );
                                            }
                                          },
                                          () => {
                                            var badItem: ICartItems = {
                                              ProductId:
                                                this.cartItems[prodC].ProductId,
                                              DisplayName:
                                                this.cartItems[prodC]
                                                  .DisplayName,
                                              ImageUrl:
                                                this.cartItems[prodC].ImageUrl,
                                              Price:
                                                this.cartItems[prodC].Price,
                                              Quantity:
                                                this.cartItems[prodC].Quantity,
                                            };
                                            this.orderService.cart =
                                              this.orderService.deleteItem(
                                                badItem
                                              );
                                            localStorage.removeItem(
                                              'cartItems'
                                            );
                                            localStorage.setItem(
                                              'cartItems',
                                              JSON.stringify(
                                                this.orderService.getCart()
                                              )
                                            );
                                            var newCount =
                                              localStorage.getItem('prodCount');
                                            var count = Number(newCount) - 1;
                                            localStorage.removeItem(
                                              'prodCount'
                                            );
                                            localStorage.setItem(
                                              'prodCount',
                                              count.toString()
                                            );
                                            this.cartItems =
                                              this.orderService.getCart();
                                            this.onlineorder
                                              .calculateTax()
                                              .subscribe(
                                                (thing2) => thing2,
                                                (error) => console.log(error),
                                                () => {
                                                  this.orderService
                                                    .updateShipMethodPlusTotals2()
                                                    .subscribe();
                                                }
                                              );
                                            this.showError(
                                              'createAccount.toastPopup.errors.createAccountError',
                                              'Error',
                                              true
                                            );
                                          }
                                        );
                                    }
                                  }
                                  this.spinner.hide();
                                  this.zone.run(() => {
                                    this.app.loggedIn = true;
                                    this.cdRef.detectChanges();
                                    setTimeout((router: Router) => {
                                      this.app.myRepID = this.repId();
                                      this.router.navigateByUrl(
                                        'shop/from/' + this.repId()
                                      );
                                    }, 1000);
                                  });
                                },
                              });
                            }
                          );
                        },
                      });
                  }
                }
              );
            }
          )
      );
  }
  onAccountCreated() {
    // You can either directly call your login service logic here
    // OR just call the same method you use after a normal login

    console.log('Account created successfully, setting loggedIn = true');

    // Example: update shared app state
    this.app.loggedIn = true; // if injected
    // or trigger a function that app.component.ts listens for
  }

  onSelectionChange(selectedValue: string) {
    var id: number = +selectedValue;
    // do something here. need to make custMessage Show up with correct placeholder
    for (var t = 0; t < this.displayRefMarketTypes.length; t++) {
      if (id === this.displayRefMarketTypes[t].ID) {
        this.custPlaceHolder = this.displayRefMarketTypes[t].InputLabel;
      }
    }
  }

  setNewCustLang(selectedValue: string) {
    if (selectedValue == 'en') localStorage.setItem('newLocaleId', '1');
    else localStorage.setItem('newLocaleId', '134');
  }

  ngOnInit(): void {
    //this.getMarketTypes();
    //this.openLoginDialog();
    //this.getMarketTypes();
    //this.openLoginDialog();
    //In case of refresh, remove these local storage items.
    localStorage.removeItem('accountCreateFields');
    localStorage.removeItem('validatedAddress');

    //make the call to get the market types
    this._createAccountService.getMarketTypes().subscribe(
      (res) => {
        this.refMarketTypes = res;
        //console.log(res);
      },
      (error) => console.log(error),
      () => {
        //now handle the market types and map them to the control
        for (var x = 0; x < this.refMarketTypes.length; x++) {
          if (
            this.refMarketTypes[x].IsActive &&
            this.refMarketTypes[x].IsAvailableAtCustomerSignup &&
            this.refMarketTypes[x].ID != 1
          ) {
            // add the market type to the array
            this.displayRefMarketTypes.push(this.refMarketTypes[x]);
          }
        }
        const control = this.createAccountForm.get('custLocale');

        if (control && !control.touched) {
          control.markAsTouched();
        }
        //set the default value to Consultant and set placeholder text.
        this.createAccountForm.controls['custHow'].setValue(9);
        this.custPlaceHolder =
          'Enter Consultants first and last name, tell us more.';

        this.sub = this._route.params.subscribe((params) => {
          let id = +params['id'];
          this._productService
            .getRepInfo(id.toString())
            .subscribe((rep: IRepPublicData) => {
              this.rep = rep;
              this.app.rep = rep;
            });
          localStorage.setItem('repId', id.toString());
        });
      }
    );
  }
}
export class marketType {
  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }

  id: number;
  name: string;
}
